'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * SellerLeadCardBody.
 *
 * Use to display the property address information.
 */
var SellerLeadCardBody = react.forwardRef(function (props, ref) {
  var styles = react.useStyles();
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    ref: ref
  }, props, {
    className: utils.cx('chakra-seller-lead-card__body', props.className),
    __css: styles.body
  }));
});
SellerLeadCardBody.displayName = 'SellerLeadCardBody';
exports.SellerLeadCardBody = SellerLeadCardBody;